import React from 'react';
import { Button } from './ui/button';
import { renderRichText } from '../utils/rich-text';
import type { Form } from '../interfaces/form.interface';

interface QuestionMessageProps {
  configuration: Form;
  onConfirm: () => void;
  onReject: () => void;
  isRejecting?: boolean;
}

export const QuestionMessage: React.FC<QuestionMessageProps> = ({ 
  configuration, 
  onConfirm, 
  onReject,
  isRejecting = false
}) => {
  return (
    <div className="space-y-6">
      <div className="text-center">
        {configuration.theme?.content?.paragraphs?.confirmation?.map((paragraph, index) => (
          <p key={index} style={{ color: configuration.theme?.visual?.textColor || '#333333' }}>
            {renderRichText(paragraph)}
          </p>
        ))}
      </div>
      
      <div className="flex justify-center space-x-4">
        <Button
          type="button"
          onClick={onConfirm}
          disabled={isRejecting}
          className="cursor-pointer"
          style={{
            background: configuration.theme?.buttons?.style?.background || '#1890ff',
            borderColor: configuration.theme?.buttons?.style?.background || '#1890ff',
            color: configuration.theme?.buttons?.style?.color || '#ffffff',
            borderRadius: '20px',
            height: '50px',
            padding: '0 40px',
            fontSize: '16px'
          }}
        >
          {configuration.theme?.buttons?.text?.accept || 'Aceptar'}
        </Button>
        
        <Button
          type="button"
          onClick={onReject}
          disabled={isRejecting}
          className="cursor-pointer"
          style={{
            background: configuration.theme?.buttons?.style?.background || '#1890ff',
            borderColor: configuration.theme?.buttons?.style?.background || '#1890ff',
            color: configuration.theme?.buttons?.style?.color || '#ffffff',
            borderRadius: '20px',
            height: '50px',
            padding: '0 40px',
            fontSize: '16px'
          }}
        >
          {isRejecting ? (
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          ) : (
            configuration.theme?.buttons?.text?.reject || 'Rechazar'
          )}
        </Button>
      </div>
    </div>
  );
};
